import { MultiSelect } from '@mantine/core'
import React from 'react'

import { DefaultMultiSelectFilterProps } from '../../hooks/useDebouncedFilterValue/use-debounced-filter-value'
import useDebouncedFilterValue from '../../hooks/useDebouncedFilterValue/useDebouncedFilterValues'

const DefaultMultiSelectFilter = ({
  sortFilter,
  filterDefinition,
}: DefaultMultiSelectFilterProps): React.ReactElement => {
  const { options, label } = filterDefinition

  const { value, onChange } = useDebouncedFilterValue<string[]>({
    filterDefinition,
    sortFilter,
  })

  return (
    <MultiSelect
      searchable
      data={options}
      label={label}
      clearable={false}
      disabled={options.length === 0}
      value={value}
      onChange={onChange}
    />
  )
}

export default DefaultMultiSelectFilter
